package component.empty

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.rounded.Refresh
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import feature.app.AppViewModel

@Composable
fun EmptyData(name: String = "", viewModel: AppViewModel, onClickRetry: () -> Unit = {}) {
    val isLoading = viewModel.isLoading.collectAsState()
    if (!isLoading.value) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .height(400.dp),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(
                text = "Oops, there is nothing to show here, please come back later or try reloading",
                Modifier
                    .padding(start = 20.dp, end = 20.dp, bottom = 30.dp),
                fontSize = 30.sp,
                lineHeight = 50.sp
            )
            Icon(

                Icons.Rounded.Refresh,
                contentDescription = "Reload",
                modifier = Modifier
                    .size(90.dp)
                    .clickable { onClickRetry() })
        }
    }

}